import { Box, Loading, Typography } from '@iheartjane/reefer';
import type { PropsWithChildren, ReactNode } from 'react';

import { useKioskSpacing } from '@jane/kiosk/hooks';

export type ProductDetailsSectionProps = PropsWithChildren<{
  ariaLabel?: string;
  isLoading: boolean;
  title?: ReactNode;
}>;

export const ProductDetailsSection = ({
  children,
  isLoading,
  title,
  ariaLabel,
}: ProductDetailsSectionProps) => {
  const { defaultSpacing, getKioskSpacing } = useKioskSpacing();
  return (
    <Box
      border="transparent-black-five"
      borderRadius="lg"
      p={defaultSpacing}
      ariaLabel={ariaLabel}
      mb={24}
    >
      {title && (
        <Typography mb={getKioskSpacing(24, 8)} variant="body-semibold">
          {title}
        </Typography>
      )}
      {isLoading ? (
        <Box position="relative">
          <Loading color="black" size="lg" />
        </Box>
      ) : (
        children
      )}
    </Box>
  );
};
